import React, {useState} from "react";
import {components} from "react-select";
import {InternationalizationIcon} from "../../../icons/InternationalizationIcon";

export const CustomSingleValueIcon = (props) => {
    const [hovered, setHovered] = useState(false);
    const isCollapsed = props.selectProps.isCollapsed;
    const noHoverStyle = props.selectProps.noHoverStyle;

    const renderValue = () => {
        if (isCollapsed) {
            return;
        }
        return (<span className={'text-ellipsis'}>{props.children}</span>);
    }

    return (
        <components.SingleValue {...props}>
            <div className={'internationalization-select-wrapper'}
                 onMouseEnter={() => setHovered(true)}
                 onMouseLeave={() => setHovered(false)}>
                <InternationalizationIcon fill={noHoverStyle ? '#000' : hovered ? '#FFF' : '#93939E'}/>
                {renderValue()}
            </div>
        </components.SingleValue>
    );
};